import React, { Component } from 'react';
import Item from './components/Item/Item';
import './style.scss';
import { connect } from 'react-redux'
import { showModal, MODAL_PRESENTATION_FORM } from '../../../../modules/modals';
import { getFolderPresentation } from '../../actions';
import Spiner from '../../../helpers/Spiner/Spiner';
import { getParams } from '../../../PresentationsStart/actions';

class PresentationItems extends Component {
  state = {
    urlApi: '',
    site: ''
  };
  componentDidMount = async () => {
    const {folder} = this.props;
    const params = await getParams();
    this.setState({
      urlApi: params.presentationApi,
      site: params.presentationSite,
    })
    if(folder && folder.id){
      this.props.getFolderPresentation(folder.id);
    }
    
  }
  render() {
    const {presentations, presentations_loaded, folder} = this.props;
    const {urlApi, site} = this.state;
    return (
      <div className="question-container PresentationItems">
        <div className="question-types-block">
          {folder && <div className="actions">
            <div className="add-present" onClick={() => {
              const { showModal } = this.props;
              showModal({
                modalType : MODAL_PRESENTATION_FORM,
                modalProps : {
                  initialValues: {
                    time_limit_question: 1
                  }
                }
              });
            }}><i className="fas fa-plus"></i></div>
          </div>}
          <div className="col-md-12">
            {!presentations_loaded && <Spiner />}
            {presentations_loaded && presentations.map(item => <Item siteUrl={site} urlApi={urlApi} key={'presentation-' + item.id} showModal={this.props.showModal} presentation={item} />)}
          </div>
        </div>
      </div>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
  presentations: state.folders.presentations,
  presentations_loaded: state.folders.presentations_loaded,
  folder: state.folders.item,
})

const mapDispatchToProps = {
  showModal,
  getFolderPresentation
}

export default connect(mapStateToProps, mapDispatchToProps)(PresentationItems)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Presentations/components/PresentationItems/PresentationItems.jsx